type Exception {
  id: String!
  timestamp: String!
  type: ExceptionType!
  description: String!
  statusCode: Int
}

enum ExceptionType {
  INVALID_TYPE
  BUSINESS
  SERVICE_NOT_AVAILABLE
  INFRASTRUCTURE
  UNEXPECTED
  SECURITY_VIOLATION
}

type NewFee {
  fee_type: FeeType!
  value: String!
}
